import React, { useState, useEffect, useRef } from 'react'
import AppInput from '../../Components/AppInput/AppInput'
import { paymentMethodOptions, reimbursementOptions } from '../../Constant/Options'
import { hasError, formatTimestampToInputDate } from '../../utils'
import { useDispatch, useSelector } from 'react-redux';
import { AlignLeft, Calendar, DollarSign, FileText, IndianRupee } from 'lucide-react';
import AppSelect from '../../Components/AppSelect/AppSelect';
import FileUpload from '../../Components/FileUpload/FileUpload';
import AppButton from '../../Components/AppButton/AppButton';
import { setApiErrorJson, setApiJson } from '../../Redux/Actions/ApiAction';
import { CashbookValidationScheema } from '../../ValidationScheema/CahbookValidation';
import { ApiHit } from '../../Api/ApiHit';
import { addCashRecord, updateCashrecord, searchUser } from '../../Constant/Constant';
import { getCahbookUser, getSelectedAccount, getSelectedBook } from '../../Storage/Storage';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

function AddCash({ cashMethod, isEditMode }) {
  const ApiReducer = useSelector((state) => state.ApiReducer);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [userOptions, setUserOptions] = useState([]);
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const dateConvertedRef = useRef(false);
  const lastRecordIdRef = useRef(null);

  // Get today's date in YYYY-MM-DD format for max attribute
  const today = new Date().toISOString().split('T')[0];

  // Fetch users for dropdown
  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const selectedAccountId = getSelectedAccount()?._id;
      const selectedBookId = getSelectedBook()?._id;

      // If no account or book selected, don't fetch users
      if (!selectedAccountId || !selectedBookId) {
        setUserOptions([]);
        return;
      }

      const json = {
        page: 1,
        limit: 100,
        search: {
          accountId: selectedAccountId,
          bookId: selectedBookId
        }
      };
      const res = await ApiHit(json, searchUser);

      if (res && res.data.docs && Array.isArray(res.data.docs)) {
        const options = res.data.docs.map(user => ({
          value: user._id,
          label: `${user.name} (${user.roleId?.roleName || 'N/A'})`
        }));
        setUserOptions(options);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
      toast.error("Failed to load users");
    }
  };

  // Convert timestamp to date input format when in edit mode
  useEffect(() => {
    const currentRecordId = ApiReducer?.apiJson?._id;

    // Reset conversion flag when record changes
    if (currentRecordId !== lastRecordIdRef.current) {
      dateConvertedRef.current = false;
      lastRecordIdRef.current = currentRecordId;
    }

    if (isEditMode && ApiReducer?.apiJson?.date && !dateConvertedRef.current) {
      const dateValue = ApiReducer.apiJson.date;
      // Check if date is in timestamp format (number)
      if (typeof dateValue === 'number') {
        const formattedDate = formatTimestampToInputDate(dateValue);
        console.log('Converting timestamp:', dateValue, 'to:', formattedDate);

        // Extract userId if it's an object (populated)
        const userId = ApiReducer.apiJson.userId?._id || ApiReducer.apiJson.userId;

        dispatch(setApiJson({
          ...ApiReducer.apiJson,
          date: formattedDate,
          userId: userId
        }));
        dateConvertedRef.current = true;
      }
    }
  }, [isEditMode, ApiReducer?.apiJson?._id, ApiReducer?.apiJson?.date])





  const handleSubmit = () => {
    setSubmitLoading(true);

    let dataToValidate = { ...ApiReducer?.apiJson, cashMethod: cashMethod };
    if (cashMethod === 'cashOut') {
      dataToValidate.userId = getCahbookUser()?._id;
    }

    CashbookValidationScheema(dataToValidate).then((error) => {
      dispatch(setApiErrorJson(error));

      if (Object.keys(error).length === 0) {

        let json = {
          ...ApiReducer?.apiJson,
          cashMethod: cashMethod,
          accountId: getSelectedAccount()?._id,
          bookId: getSelectedBook()?._id
        };

        // 👉 Add userId ONLY for add mode
        if (!isEditMode) {
          json.userId =
            cashMethod === 'cashIn'
              ? (ApiReducer?.apiJson?.userId || getCahbookUser()?._id)
              : getCahbookUser()?._id;
        }

        // 👉 Edit mode me userId kabhi send mat karo
        if (isEditMode && json.userId) {
          delete json.userId;
        }

        json.date = new Date(json.date).getTime();

        const apiEndpoint = isEditMode ? updateCashrecord : addCashRecord;
        const successCode = isEditMode ? 200 : 201;

        console.log("Final Payload:", json);

        ApiHit(json, apiEndpoint).then((res) => {
          console.log("res", res);
          if (res?.statusCode === successCode) {
            toast?.success(res?.message || (isEditMode ? 'Record updated successfully' : 'Record added successfully'))
            navigate("/cashbook")
          } else {
            toast?.error(res?.error || 'Something went wrong')
          }
        }).catch((err) => {
          console.error(err);
          toast?.error('Failed to save record')
        }).finally(() => {
          setSubmitLoading(false);
        })
      } else {
        setSubmitLoading(false);
      }
    });
  };


  // Don't render form until cashMethod is properly set
  if (!cashMethod) {
    return (
      <div className="bg-white p-4 sm:p-6 md:p-8 border rounded-xl mb-4 sm:mb-6">
        <div className="flex items-center justify-center h-64">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
            <p className="text-gray-600">Loading form...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="bg-white p-4 sm:p-6 md:p-8 border rounded-xl mb-4 sm:mb-6">
        <div className="text-base sm:text-lg font-medium mb-4 sm:mb-5 flex justify-between items-center">
          <span className='capitalize'>{`${cashMethod} Information`}</span>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 mb-4 sm:mb-6">


          <AppInput
            title="Amount"
            placeholder="Enter amount"
            name="amount"
            important={true}
            error={hasError('amount', ApiReducer)}
            icon={<IndianRupee size={18} />}
            type="number"
          // disabled={submitLoading}
          />
          <AppInput
            title="Date"
            placeholder="Select date"
            name="date"
            important={true}
            error={hasError('date', ApiReducer)}
            icon={<Calendar size={18} />}
            type="date"
            max={today}
          // disabled={submitLoading}
          />

          {/* Show user dropdown only for Cash In */}
          {cashMethod === 'cashIn' && (
            <AppSelect
              title="User"
              name="userId"
              options={userOptions}
              important={true}
              placeholder="Select user"
              error={hasError('userId', ApiReducer)}
            // disabled={submitLoading}
            />
          )}

          <AppSelect
            title="Payment Method"
            name="paymentMethod"
            options={paymentMethodOptions}
            important={true}
            placeholder="Select payment method"
            error={hasError('paymentMethod', ApiReducer)}
          // disabled={submitLoading}
          />

        </div>
        <div className="mb-4 sm:mb-6">
          <AppInput
            title="Description"
            placeholder="Enter expense description"
            name="description"
            important={false}
            error={hasError('description', ApiReducer)}
            icon={<AlignLeft size={18} />}
          // disabled={submitLoading}
          />
        </div>
        <div className="mb-4 sm:mb-6">
          <FileUpload
            title="Expense Proof"
            name="proofUrl"
            allowed={["img", "pdf"]}
            important={cashMethod === 'cashOut'}
            error={hasError('proofUrl', ApiReducer)}
            multiple={true}
          // disabled={submitLoading}
          />
        </div>
        <div className="flex flex-col sm:flex-row justify-end gap-2 sm:gap-3">
          <AppButton
            buttontext={submitLoading ? "Processing..." : (isEditMode ? "Update Record" : "Add Record")}
            variant="primary"
            onClick={handleSubmit}
            disabled={submitLoading}
            isLoading={submitLoading}
          />
        </div>
      </div>
    </div>
  )
}

export default AddCash
